<template>
  <div>
      <div class="header mt-5">
        {{ this.$vuetify.lang.t('$vuetify.visitor.visitor') }}
    </div>

    <nav-bar
        ref="navbar"
        @menu-change="menuChange"
        :menuItem="navbarList" />

    <component :is="component" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import VisitorLists from '@/components/Visitor/VisitorLists.vue'
import VisitorActivity from '@/components/Visitor/VisitorActivity.vue'

export default {
    name: 'Visitor',

    components: {
        NavBar,
        VisitorLists,
        VisitorActivity
    },

    data () {
        return {
            component: '',
            mappedTranslationNavbar: {
                VisitorLists: 'visitorLists',
                VisitorActivity: 'VisitorActivity'
            }
        }
    },

    computed: {
        navbarList () {
            const navbar = []
            for (const item of this.menuItem) {
                navbar.push(item)
            }
            return navbar
        },

        menuItem () {
            return [
                {
                    title: this.$vuetify.lang.t('$vuetify.visitor.visitorLists'),
                    path: 'VisitorLists',
                    pathName: 'list',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.visitor.visitorActivity'),
                    path: 'VisitorActivity',
                    pathName: 'activity',
                    permission: []
                }
            ]
        }
    },

    methods: {
        menuChange (payload) {
            this.component = payload.path

            const path = `/visitor/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        setActive (path) {
            let index = 0
            if (path === 'Visitor') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            this.component = this.navbarList[index].path
            const directPath = `/visitor/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.setActive(this.$router.currentRoute.name)
    }
}
</script>

<style>

</style>
